<template>
  <div class="icon-container">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'IconContainer',
  props: [],
};
</script>

<style lang="stylus" scoped>
  @require '../style/colors'

  .icon-container
    display: flex
    flex-flow: wrap
    justify-content: center
    gap: 4rem 2rem
    max-width: 90rem
    margin: 0 auto

</style>
